const state = () => ({
    sessionUserRol: [],
    sessionUserCode: '',
    userStores: [], // Session user stores
  })
  
  const actions = {}
  
  const mutations = {
    setSessionUserRol(state, rol) { state.sessionUserRol = rol },
    setSessionUserCode(state, code) { state.sessionUserCode = code },
  }
  
  const getters = {
    userCod: state => state.sessionUserCode,
    rol: state => state.sessionUserRol,
  }
  
  export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
  }
  